module.exports = __webpack_public_path__ + "static/Kim_Portrait-594016fcb089ed40c65fadaa3163337e.jpg";